/* eslint-disable no-inline-styles/no-inline-styles */
'use client';
import { useEffect, useState } from 'react';

const ChatBotIframe = ({ chatBotURL }: { chatBotURL: string }) => {
  useEffect(() => {
    const iframe = document.getElementById('chatbot-iframe') as HTMLIFrameElement;
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== chatBotURL && event.origin !== 'null') {
        return;
      }

      const { width, height } = JSON.parse(event.data);
      if (iframe) {
        iframe.style.width = width;
        iframe.style.height = height;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, [chatBotURL]);

  return (
    <iframe
      title="MagAssist"
      id="chatbot-iframe"
      src={chatBotURL}
      sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
      style={{
        position: 'fixed',
        bottom: '95px',
        right: '20px',
        border: 'none',
        width: '55px', // initial size
        height: '55px', // initial size
        transition: 'width 0.3s, height 0.3s',
        zIndex: 9000,
      }}
    ></iframe>
  );
};

const MagAssist = () => {
  const [chatBotURL, setChatBotURL] = useState<string | null>(null);

  useEffect(() => {
    setChatBotURL(process.env.NEXT_PUBLIC_CHATBOT ?? null);
  }, []);

  if (!chatBotURL) {
    return null;
  }

  return <ChatBotIframe chatBotURL={chatBotURL} />;
};

export default MagAssist;
